import { useEffect } from 'react';

import piwik from '../services/analytics';

export const usePageView = page => {
  useEffect(() => {
    piwik.trackPageView(page);
  }, [page]);
};
